import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'app-breeding-center',
  templateUrl: './breeding-center.component.html',
  styleUrls: ['./breeding-center.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class BreedingCenterComponent implements OnInit {

  public deeplink;

  constructor(public route:ActivatedRoute, public sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.deeplink = params['id']
      if(this.deeplink==undefined || this.deeplink==''){
        this.deeplink = this.sanitizer.bypassSecurityTrustResourceUrl("https://market.kryptomon.co/breed/contracts/undefined/tokens/undefined")
        console.log(this.deeplink)
      }else{
        this.deeplink = this.sanitizer.bypassSecurityTrustResourceUrl("https://market.kryptomon.co/breed/contracts/0x04b0f7d5cb2ce4688497f2525748fb7a9affa394/tokens/"+params['id'])
        console.log(this.deeplink)
      }
  });
  }

}
